import {button,escapeHtml,message} from '../ui/components.js';
import {
  formatPlannedDateTime,
  isoToLocalInputValue
} from './schedule.js';

function duration(minutes){
  if(minutes==null)return '—';
  const value=Number(minutes);
  const days=Math.floor(value/1440);
  const hours=Math.floor((value%1440)/60);
  const mins=value%60;
  return [
    days?days+' d':null,
    hours?hours+' h':null,
    mins?mins+' min':null
  ].filter(Boolean).join(' ')||'0 min';
}

function conflictMessage(summary){
  if(!summary?.materialConflict)return '';
  const difference=Number(summary.differenceMinutes);
  const text=difference>0
    ?'Wpisane okno jest dłuższe od sumy czasów etapów o '+duration(Math.abs(difference))+'.'
    :'Wpisane okno jest krótsze od sumy czasów etapów o '+duration(Math.abs(difference))+'.';
  return message({text,kind:'warning'});
}

function coverageMessage(summary){
  if(summary?.stageDurationCoverage!=='partial')return '';
  return message({
    text:'Część etapów nie ma czasu. Suma etapów jest częściowa i nie jest porównywana z końcem sesji.',
    kind:'info'
  });
}

export function sessionScheduleMarkup({
  session,
  summary,
  locale='pl-PL',
  timeZone,
  offline=false,
  editable=true
}={}){
  const start=session?.plannedStartAt||null;
  const end=session?.plannedEndAt||null;
  const startLabel=start?formatPlannedDateTime(start,{locale,timeZone}):'Nie ustawiono';
  const endLabel=end?formatPlannedDateTime(end,{locale,timeZone}):'Nie ustawiono';

  const form=editable
    ?'<form id="journal-schedule-form" class="smoker-form" novalidate>'+
      (offline?message({
        text:'Pracujesz offline. Termin zostanie zapisany lokalnie i zsynchronizowany później.',
        kind:'warning'
      }):'')+
      '<div class="form-grid">'+
      '<label class="field"><span class="field-label">Planowany start</span>'+
      '<input name="plannedStart" type="datetime-local" value="'+escapeHtml(isoToLocalInputValue(start,{timeZone}))+'"></label>'+
      '<label class="field"><span class="field-label">Planowany koniec</span>'+
      '<input name="plannedEnd" type="datetime-local" value="'+escapeHtml(isoToLocalInputValue(end,{timeZone}))+'"></label>'+
      '</div><div class="actions">'+button({label:'Zapisz termin',type:'submit'})+'</div></form>'
    :'';

  return '<section class="journal-schedule">'+
    '<div class="panel journal-schedule-summary">'+
    '<h2>Plan czasowy</h2>'+
    '<p><strong>Start:</strong> '+escapeHtml(startLabel)+'</p>'+
    '<p><strong>Koniec:</strong> '+escapeHtml(endLabel)+'</p>'+
    '<p><strong>Suma czasów etapów:</strong> '+escapeHtml(duration(summary?.totalStageDurationMinutes))+'</p>'+
    '<p><strong>Okno sesji:</strong> '+escapeHtml(duration(summary?.plannedWindowMinutes))+'</p>'+
    '</div>'+
    coverageMessage(summary)+conflictMessage(summary)+form+
    '</section>';
}
